import React from 'react';
import { Layout } from 'antd';
import shellStyles from '../../OwlShellContainer.module.scss';
import useOwlShellSider, { DEFAULT_WIDTH } from './useOwlShellSider';

type Props = React.PropsWithChildren;

const OwlShellSiderComponent: React.FC<Props> = ({ children }) => {
  const [{ siderWidth }, owlShellSiderHandler] = useOwlShellSider();
  const siderRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const siderElement = siderRef.current;
    if (!siderElement) {
      return;
    }

    siderElement.addEventListener('mouseover', owlShellSiderHandler.expand);
    siderElement.addEventListener('mouseout', owlShellSiderHandler.collapse);

    return () => {
      siderElement.removeEventListener(
        'mouseover',
        owlShellSiderHandler.expand
      );
      siderElement.removeEventListener(
        'mouseout',
        owlShellSiderHandler.collapse
      );
    };
  }, [owlShellSiderHandler]);

  return (
    <Layout.Sider
      ref={siderRef}
      className={shellStyles.sider}
      width={siderWidth}
      collapsed={siderWidth === DEFAULT_WIDTH}
      trigger={null}
    >
      {children}
    </Layout.Sider>
  );
};

export default OwlShellSiderComponent;
